module.exports = "../../../../platform/assets/pageMainIcon/icon-zuzhi-1-blue.svg";